export function yn(value: boolean | string | number): string {
  if (typeof value === 'string') {
    if (!value) {
      return 'N';
    }

    value = value.trim().toUpperCase();

    if (value === 'Y' || value === 'YES') {
      return 'Y';
    } else {
      return 'N';
    }
  } else if (typeof value === 'number') {
    if (value >= 1) {
      return 'Y';
    } else {
      return 'N';
    }
  } else {
    if (value) {
      return 'Y';
    } else {
      return 'N';
    }
  }
}
